import { render, staticRenderFns } from "./IconButtonText.vue?vue&type=template&id=5334c3a8&scoped=true&"
import script from "./IconButtonText.vue?vue&type=script&lang=js&"
export * from "./IconButtonText.vue?vue&type=script&lang=js&"
import style0 from "./IconButtonText.vue?vue&type=style&index=0&id=5334c3a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5334c3a8",
  null
  
)

export default component.exports